export interface FeatureFlag {
  brand: {
    name: string
    website: string
    supportEmail: string
  }
  ui: {
    headerContactUsType: 'icon' | 'text'
  }
  customerCode: string
  locale: {
    default: string
  }
  currency: {
    default: string
  }
  activeSearchModes: {
    destination: boolean
    attributes: boolean
    events: boolean
    visa: boolean
    accommodation: boolean
    package: boolean
  }
  activeSearchModesPriority: Array<
    | 'Destination'
    | 'Attributes'
    | 'Events'
    | 'Visa'
    | 'Accommodation'
    | 'Package'
  >
  activeResults: {
    flight: boolean
    hotel: boolean
    car: boolean
    aircraft: boolean
  }
  paymentProvider: {
    active: 'jcc' | 'paypal' | 'sslcommerz' | 'ngenius' | 'bridgerpay'
  }
  localization: {
    sex?: Record<string, string>
  }
  showTermsCheckboxInPayment: {
    enabled: boolean
  }
  paymentMethods: {
    enabled: boolean
    methods: {
      card: boolean
      wallet: boolean
    }
  }
  minimumSwapAmount: number
  authMode: 'auth0' | 'legacy'
  loyaltyAccount: {
    show: boolean
  }
  bagsCount: {
    default: number | string
  }
  searchResultsPriority: Array<'aircraft' | 'flight' | 'hotel' | 'car'>
  searchPageSectionsPriority: {
    beforeSearch: Array<'Offer' | 'Visa' | 'Package' | 'Curated'>
    afterSearch: Array<
      'SearchResult' | 'Offer' | 'Visa' | 'Package' | 'Curated'
    >
  }
  searchPanel: {
    hasRoundTripDepartureTime: boolean
    hasBagInput: boolean
  }
  cookiePolicy?: {
    enabled: boolean
  }
  displayPaymentButton?: boolean
  chatBot?: {
    enabled: boolean
  }
  passengersDefaultCount: {
    adults: number
    children: number
  }
  offersResults: {
    enabled: boolean
    flightEnabled: boolean
    hotelEnabled: boolean
  }
  showProviderNames: boolean
  curatedTrips: {
    enabled: boolean
    tiersEnabled: boolean
  }
  visaResults: {
    enabled: boolean
  }
  multiRoom: boolean
  affiliateProgram: boolean
  limitChildrenByAdults: boolean
  hotelResultsFilters?: Array<
    | 'sortOptions'
    | 'roomType'
    | 'starRating'
    | 'bedType'
    | 'viewType'
    | 'meals'
    | 'refundability'
    | 'hotels'
    | 'stationPoi'
    | 'hotelLocation'
  >
  providerFilter: {
    enabled: boolean
  }
  itineraryBundleOnly: {
    enabled: boolean
  }
  announcementBanner?: string
}

const featureFlag: FeatureFlag = {
  brand: {
    name: 'City Of Dreams',
    website: 'cityofdreamsmed.com.cy',
    supportEmail: 'support@cityofdreamsmed.com.cy',
  },
  ui: {
    headerContactUsType: 'text',
  },
  customerCode: import.meta.env.VITE_CUSTOMER_CODE,
  locale: {
    default: 'en',
  },
  currency: {
    default: 'EUR',
  },
  activeSearchModes: {
    destination: true,
    attributes: true,
    events: false,
    visa: false,
    accommodation: true,
    package: false,
  },
  activeSearchModesPriority: [
    'Destination',
    'Attributes',
    'Events',
    'Visa',
    'Accommodation',
    'Package',
  ],
  activeResults: {
    flight: true,
    hotel: true,
    car: false,
    aircraft: false,
  },
  paymentProvider: {
    active: 'jcc',
  },
  localization: {},
  showTermsCheckboxInPayment: {
    enabled: false,
  },
  paymentMethods: {
    enabled: false,
    methods: {
      card: false,
      wallet: false,
    },
  },
  minimumSwapAmount: 10,
  authMode: 'legacy',
  loyaltyAccount: {
    show: false,
  },
  bagsCount: {
    default: 'null',
  },
  searchResultsPriority: ['aircraft', 'flight', 'hotel', 'car'],
  searchPageSectionsPriority: {
    beforeSearch: ['Visa', 'Package', 'Curated', 'Offer'],
    afterSearch: ['Visa', 'Package', 'Curated', 'SearchResult', 'Offer'],
  },
  searchPanel: {
    hasRoundTripDepartureTime: false,
    hasBagInput: true,
  },
  cookiePolicy: {
    enabled: false,
  },
  displayPaymentButton: true,
  chatBot: {
    enabled: false,
  },
  passengersDefaultCount: {
    adults: 2,
    children: 0,
  },
  offersResults: {
    enabled: true,
    flightEnabled: true,
    hotelEnabled: true,
  },
  showProviderNames: false,
  curatedTrips: {
    enabled: false,
    tiersEnabled: true,
  },
  visaResults: {
    enabled: false,
  },
  multiRoom: true,
  affiliateProgram: false,
  limitChildrenByAdults: true,
  hotelResultsFilters: [
    'sortOptions',
    'starRating',
    'viewType',
    'meals',
    'refundability',
    'hotels',
    'stationPoi',
    'hotelLocation',
    'roomType',
    'bedType',
  ],
  providerFilter: {
    enabled: false,
  },
  itineraryBundleOnly: {
    enabled: false,
  },
}

export default featureFlag
